// client/src/coms/views/canvas_parts/CanvasStatusBar.js
import React from 'react';

export default function CanvasStatusBar({ displayZoomPercent, viewRotation, documentSize, activeLayer, activeToolLabel, selectionState }) {
  const zoomLabel = `${Math.round(Number(displayZoomPercent) || 0)}%`;
  const rotationLabel = `${Math.round(Number(viewRotation) || 0)}°`;
  const canvasSizeLabel = `${Math.round(Number(documentSize && documentSize.width) || 0)} × ${Math.round(Number(documentSize && documentSize.height) || 0)}`;
  const activeLayerName = String(activeLayer && activeLayer.name ? activeLayer.name : 'No layer').trim();

  return (
    <div
      style={{
        height: 28,
        flex: '0 0 28px',
        borderTop: '1px solid rgba(0,0,0,0.55)',
        background: '#343434',
        display: 'flex',
        alignItems: 'center',
        gap: 18,
        padding: '0 10px',
        boxSizing: 'border-box',
        color: 'rgba(238,242,247,0.78)',
        fontSize: 12,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      }}
    >
      <span>{zoomLabel}</span>
      <span>Rotation {rotationLabel}</span>
      <span>Canvas {canvasSizeLabel}</span>
      <span>Layer {activeLayerName}</span>
      <span>Tool {activeToolLabel || 'Pen Brush'}</span>
      {selectionState ? <span>Selection active</span> : null}
      <span style={{ flex: '1 1 auto' }} />
    </div>
  );
}
